export enum YourTeamGridTemplateId {
    HEADER = 'header',
    CONTENT = 'content',
}
